import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppealsAndGrievancesQueueComponent } from './appeals-and-grievances-queue.component';
import { SharedModule } from '@shared/shared.module';
import { QueueActionButtonsComponent } from '@shared/component/queue-action-buttons/queue-action-buttons.component';

@NgModule({
  declarations: [
    AppealsAndGrievancesQueueComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    QueueActionButtonsComponent,
  ],
  exports: [
    AppealsAndGrievancesQueueComponent
  ]
})
export class AppealsAndGrievancesQueueModule { }
